import React, { useState, useEffect } from 'react';
import GaugeChart from 'react-gauge-chart';

export function MFXGaugeChart(props) {

    return (
        <>
            {props.chart.Data?.length > 0 &&
                props.chart.Data.map(chart => {
                    return (
                        <>
                            <h2>{chart.label}</h2>
                            <GaugeChart className="mfx-gauge-chart" nrOfLevels={20} colors={['#d12d2d', '#eede34', '#5BE12C']} textColor={'var(--fontColor)'} percent={isNaN(parseInt(chart.value)) ? 0 : parseInt(chart.value) / 100} />
                        </>
                    );
                })}
            {!props.chart.Data?.length &&
                <GaugeChart className="mfx-gauge-chart" nrOfLevels={20} colors={['#d12d2d', '#eede34', '#5BE12C']} textColor={'var(--fontColor)'} percent={0} />
            }
        </>
    );
}
